'use client'
import { useEffect } from 'react'

// Everything behind the modal sheet (page body, footer, the disclosure bar)
// is inert while it is present, so keyboard and screen-reader focus cannot
// wander under the scrim. The top bar stays live: its close button is one of
// the sheet's exits.
const BEHIND_SHEET = '.ht-page-shell, .nav-disclaimer'

export const useSheetInert = (present: boolean) => {
  useEffect(() => {
    if (!present) {
      return undefined
    }
    const targets = [...document.querySelectorAll<HTMLElement>(BEHIND_SHEET)]
    targets.forEach((element) => element.setAttribute('inert', ''))
    return () => targets.forEach((element) => element.removeAttribute('inert'))
  }, [present])
}
